import React from 'react';

import { useServices } from 'hooks/useServices';
import { useServiceState } from 'hooks/useServiceState';

export const useProductsService = () => {
  const { getProducts: getProductsService } = useServices();

  const [productsState, getProductsWithParams] = useServiceState(
    getProductsService
  );

  const getProducts = React.useCallback(() => {
    getProductsWithParams();
  }, [getProductsWithParams]);

  return { productsState, getProducts };
};
